// extracted by mini-css-extract-plugin
export var items = "fc-products-module--items--e8e62";
export var root = "fc-products-module--root--2e0f2";
export var title = "fc-products-module--title--1dea6";